import React from "react";
import parse from 'html-react-parser';
import usePrivacyPolicy from "hooks/usePrivacyPolicy";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import notify from "../../assets/images/Notification.png";


const PrivacySection = () => {
  const { policyData } = usePrivacyPolicy();

  return (
    <div className="container-box">
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center bg-white">
        <h2>
          {policyData?.title}
        </h2>
        <Nav.Link as={Link} to="/notification" href="/notification">
          <div type="" className=" position-relative">
            <img src={notify} alt="" />
            <span className="position-absolute  badge-custom  rounded-circle">
              <span className="visually-hidden">New alerts</span>
            </span>
          </div>
        </Nav.Link>
      </div>
      <div className="outer-white job-details-page">
        <p className="information-text">
          {parse(policyData?.description || "")}
        </p>
      </div>
    </div>
  );
};

export default PrivacySection;
